import { shallowEqual as structureShallowEqual } from 'shallow-equal';

type Structure = Record<string, unknown> | unknown[];

export const noop = (): undefined => {};

export const isNil = (v: unknown): boolean => v === null || typeof v === 'undefined';

export const coalesceNull = <V, D>(value: V, otherwise: D): V | D =>
  isNil(value) ? otherwise : value;

export const isStructure = (value: unknown): boolean => Boolean(value) && typeof value === 'object';

export const shallowEquals = (a: unknown, b: unknown): boolean =>
  // The shallowEqual function only works for arrays and objects.
  // Arrays and objects and null all get typeof 'object' because JS Bad(TM), so exclude null.
  a === b
  || isStructure(a) && isStructure(b) && structureShallowEqual(a as Structure, b as Structure);

export const flex = (...classNames: string[]): string => {
  const classNamesString = classNames.filter(Boolean).map((c) => `flex-${c}`).join(' ');
  return `flex ${classNamesString}`;
};
